<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-document-checked"></i> {{$t('pages.mtAbnormalDisplay.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container" v-loading="loading">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.mtStd.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.mtStd.export')}}</el-button>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.daterange" type="daterange" align="right" unlink-panels :range-separator="'~'" :start-placeholder="$t('pages.mtStd.dateStartPh')" :end-placeholder="$t('pages.mtStd.dateEndPh')" :picker-options="pickerOptions0" class="mr10" style="width: 280px"></el-date-picker>
                <el-select v-model="query.balanceId" :placeholder="$t('pages.mtStd.mine')" class="handle-select mr10">
                    <el-option v-for="item in balanceArr" :key="item.id" :label="isDisplayCompanyName ? item.fullName : item.name" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.mtStd.search')}}</el-button>
            </div>
        </div>

        <!-- MT1082-2008 表9 系统工作异常显示（横向标准表样） -->
        <el-table :data="rows" border class="table" id="mytable" header-cell-class-name="table-header" :height="tableHeight">
            <el-table-column type="index" :label="$t('pages.mtStd.index')" width="60" align="center"></el-table-column>
            <el-table-column prop="name" :label="$t('pages.mtStd.mine')" min-width="150"></el-table-column>
            <el-table-column prop="count" :label="$t('pages.mtStd.cumCount')" width="100" align="center"></el-table-column>
            <el-table-column prop="cumTime" :label="$t('pages.mtStd.cumTime')" width="120" align="center"></el-table-column>
            <el-table-column v-for="n in dynamicCols" :key="'ev' + n" :label="eventLabel(n)" min-width="220" align="center">
                <template slot-scope="scope">
                    <span class="ev-cell" :title="$t('pages.mtStd.remarkEditTip')" @click="editRemark(scope.row.events[n - 1])">{{ eventText(scope.row, n) }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'mtAbnormalDisplay',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            loading: false,
            tableHeight: window.innerHeight * 0.75,
            isDisplayCompanyName: false,
            balanceArr: [],
            rows: [],
            query: {
                daterange: '',
                balanceId: 0
            }
        };
    },
    computed: {
        dynamicCols() {
            var m = 0;
            this.rows.forEach((r) => {
                if (r.events.length > m) m = r.events.length;
            });
            return Math.max(3, m);
        }
    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        this.query.daterange = [start, end];
        this.getBalance();
        this.getData();
    },
    methods: {
        eventLabel(n) {
            return this.$t('pages.mtStd.nth') + n + this.$t('pages.mtStd.nthAfter') + this.$t('pages.mtStd.status') + '\\' + this.$t('pages.mtStd.cumTime') + '\\' + this.$t('pages.mtStd.timeSpan') + '\\' + this.$t('pages.mtStd.remark');
        },
        eventText(row, n) {
            var ev = row.events[n - 1];
            return ev ? ev.text : '--';
        },
        getData() {
            if (!this.query.daterange) {
                this.$notify.warning(this.$t('pages.mtStd.dateStartPh'));
                return;
            }
            var sd = dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd 00:00:00');
            var ed = dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd 00:00:00');
            if (new Date(sd).getTime() > new Date(ed).getTime()) {
                this.$notify.warning(this.$t('pages.mtStd.rangeError'));
                return;
            }
            // 表9按矿一行：选定矿查单矿，'全部'并发查询所有矿
            var mines = this.balanceArr.filter((b) => b.id !== 0 && (this.query.balanceId == 0 || b.id === this.query.balanceId));
            this.loading = true;
            Promise.all(mines.map((m) => this.fetchMine(m, sd, ed)))
                .then((rows) => {
                    this.loading = false;
                    this.rows = rows.filter((r) => !!r);
                })
                .catch(() => {
                    this.loading = false;
                    this.$notify.error(this.$t('pages.mtStd.fetchError'));
                });
        },
        getBalance() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.isDisplayCompanyName = res.data.info1 == '是';
                        this.balanceArr = [{
                            id: 0,
                            name: this.$t('pages.mtStd.all'),
                            fullName: this.$t('pages.mtStd.all')
                        }].concat(d);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch(() => this.$notify.error(this.$t('pages.mtStd.fetchError')));
        },
        // 单矿：EquStateReport 按异常类型分组返回次数/累计时长/各次起止时刻/备注，
        // 前端拍平按时间排序为表9横向事件（状况\时长\起止时刻\备注）
        fetchMine(m, sd, ed) {
            return this.$zybhttp
                .get('Business/EquStateReport', {
                    params: {
                        balanceId: m.id,
                        start: sd,
                        end: ed
                    }
                })
                .then((res) => {
                    if (res.data.status != 0) {
                        return null;
                    }
                    var d = res.data.data || {};
                    var events = [];
                    (d.types || []).forEach((t) => {
                        (t.records || []).forEach((r) => {
                            events.push({
                                id: r.id,
                                start: r.startTime || '',
                                remark: r.remark,
                                text: this.nz(t.stateType) + '\\' + this.formatDuration(r.durationMinutes) + '\\' + this.nz(r.startTime) + '~' + (r.ongoing ? this.$t('pages.mtStd.ongoing') : this.nz(r.endTime)) + '\\' + this.nz(r.remark)
                            });
                        });
                    });
                    events.sort((a, b) => (a.start < b.start ? -1 : a.start > b.start ? 1 : 0));
                    return {
                        name: this.isDisplayCompanyName && m.fullName ? m.fullName : m.name,
                        count: d.total || 0,
                        cumTime: this.formatDuration(d.totalDurationMinutes || 0),
                        events: events
                    };
                })
                .catch(() => null);
        },
        // 表9备注可人工修改（停电/人为破坏/计划内等），对应后台 EquStateRemark
        editRemark(ev) {
            if (!ev || !ev.id) return;
            this.$prompt(this.$t('pages.mtStd.remark'), this.$t('pages.mtStd.remarkEdit'), {
                confirmButtonText: this.$t('pages.mtStd.confirm'),
                cancelButtonText: this.$t('pages.mtStd.cancel'),
                inputValue: ev.remark === '--' ? '' : ev.remark
            })
                .then(({ value }) => {
                    var form = new URLSearchParams();
                    form.append('id', ev.id);
                    form.append('remark', value || '');
                    this.$zybhttp
                        .post('Business/EquStateRemark', form)
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$message.success(res.data.msg);
                                this.getData();
                            } else {
                                this.$notify.error(res.data.msg);
                            }
                        })
                        .catch(() => this.$notify.error(this.$t('pages.mtStd.fetchError')));
                })
                .catch(() => {});
        },
        // 时长：超1小时显示“X小时Y分钟”，否则“Y分钟”
        formatDuration(mins) {
            var h = Math.floor(mins / 60);
            var m = mins % 60;
            var s = '';
            if (h > 0) s += h + this.$t('pages.mtStd.hours');
            if (m > 0 || h === 0) s += m + this.$t('pages.mtStd.minutes');
            return s;
        },
        nz(v) {
            return v === null || v === undefined || v === '' ? '--' : v;
        },
        printlist() {
            var sd = this.query.daterange ? dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd') : '';
            var ed = this.query.daterange ? dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd') : '';
            var props = [{
                    field: 'index',
                    displayName: this.$t('pages.mtStd.index'),
                    columnSize: '4%'
                },
                {
                    field: 'name',
                    displayName: this.$t('pages.mtStd.mine'),
                    columnSize: '10%'
                },
                {
                    field: 'count',
                    displayName: this.$t('pages.mtStd.cumCount'),
                    columnSize: '7%'
                },
                {
                    field: 'cumTime',
                    displayName: this.$t('pages.mtStd.cumTime'),
                    columnSize: '9%'
                }
            ];
            var data = this.rows.map((r, i) => {
                var o = {
                    index: i + 1,
                    name: r.name,
                    count: r.count,
                    cumTime: r.cumTime
                };
                for (var n = 1; n <= this.dynamicCols; n++) {
                    o['ev' + n] = this.eventText(r, n);
                    props.push({
                        field: 'ev' + n,
                        displayName: this.eventLabel(n),
                        columnSize: '18%'
                    });
                }
                return o;
            });
            print({
                printable: data,
                header: `<div style="display: flex;flex-direction: column;text-align: center"><h3>${this.$t('pages.mtAbnormalDisplay.printTitle')}（${sd} ~ ${ed}）</h3></div>`,
                properties: props,
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:left;padding:5px;10px;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.mtAbnormalDisplay.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        }
    }
};
</script>

<style scoped>
.handle-select {
    width: 150px;
}

.ev-cell {
    cursor: pointer;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}
</style>
